import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectCurrentUrl, State } from './routing.selectors';

@Injectable({
  providedIn: 'root'
})
export class RoutingService {
  currentRoute$: any;

  constructor(private store: Store<State>) {
    this.currentRoute$ = store.select(selectCurrentUrl);
  }
}
